const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站1080P起步，部分资源支持4K超清，每一帧都清晰细腻，给你影院级的视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '采用多线CDN加速技术，智能适配网络环境，无论宽带还是移动网络都能秒加载流畅播放。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '编辑团队全天候追踪最新影视动态，每日稳定更新30+内容，不错过任何一部好片。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净安全',
    desc: '绿色无广告弹窗，严格内容审核，为全年龄段观众提供安全舒适的免费观影环境。',
  },
  {
    icon: 'ri-global-line',
    title: '全终端适配',
    desc: '完美兼容手机、平板、电脑，一次收藏多端同步，走到哪里看到哪里，观影不间断。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              平台优势
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              为什么选择成全影院
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              五大核心优势，打造极致免费观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((f) => (
              <div key={f.title} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200 transition-all duration-300 cursor-default">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                  <i className={`${f.icon} text-2xl text-accent-600`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}